import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';
import { addCategoryRequest, addCategoryRequestError, addCategoryRequestSuccess } from '../../slices/Content/AddCategorySlice';
import { updateCategoryFailure, updateCategoryRequest, updateCategorySuccess } from '../../slices/Content/UpdateCategorySlice';

export const AddCategoryAPI = (data) => {
    return async (dispatch) => {
        try {
            dispatch(addCategoryRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.addCategory,
                data: data,
            })
            return dispatch(addCategoryRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(addCategoryRequestError(_error));
        }
    };
};


export const UpdateCategoryAPI = (formData) => async (dispatch) => {
  try {
    dispatch(updateCategoryRequest());
      const response = await axiosInstance({
        method: "POST",
        url: endpoints.updateCategory, // Make sure you have this endpoint defined
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      dispatch(updateCategorySuccess(response?.data));
      return response?.data;
  } catch (error) {
    dispatch(updateCategoryFailure(error.response?.data));
    throw error.response?.data;
  }
};
